import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'

import { ThemeButton, useModalContext } from '../../../../ui'
import { CompanySelectorDialog } from '../dialogs'

export const CreateIPBtn = () => {
  const { formatMessage } = useIntl()
  const navigate = useNavigate()
  const {
    actions: { open },
  } = useModalContext()
  const global = useSelector((state) => state.global)
  const isGuild = !!global.gremio

  const handleCreateIP = () => {
    if (!isGuild) {
      navigate('/inspections/ip')
    } else {
      open({
        Component: CompanySelectorDialog,
        data: { type: 'ip', guildId: global.gremio.id },
        closable: true,
        type: 'center',
        maxWidth: 'xs',
      })
    }
  }

  return (
    <ThemeButton
      color="secondary"
      labelM="sm"
      onClick={handleCreateIP}
      style={{ marginLeft: '1em' }}
    >
      {formatMessage({ id: 'pages.ipList.createIPButton.label' })}
    </ThemeButton>
  )
}
